var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IMAGE",
    clipPath: "url(#clip0_1_4590)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.194 14.0503H14.0099C13.6905 14.0503 13.3842 13.9234 13.1584 13.6976C12.9325 13.4718 12.8057 13.1655 12.8057 12.8461V10.3259C12.8057 10.0065 12.9325 9.70024 13.1584 9.47441C13.3842 9.24858 13.6905 9.1217 14.0099 9.1217H14.194C14.5134 9.1217 14.8197 9.24858 15.0455 9.47441C15.2713 9.70024 15.3982 10.0065 15.3982 10.3259V12.8463C15.3982 13.1656 15.2713 13.4719 15.0454 13.6976C14.8196 13.9234 14.5133 14.0503 14.194 14.0503Z",
    fill: "#666766",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M14.8216 9.30298C14.8983 9.46138 14.9426 9.6385 14.9426 9.82624V12.3466C14.9426 12.666 14.8157 12.9723 14.5899 13.1981C14.364 13.4239 14.0577 13.5508 13.7384 13.5508H13.5542C13.3741 13.5506 13.1963 13.5098 13.034 13.4315C13.005 13.4252 12.9753 13.4207 12.9473 13.4126C13.0499 13.6053 13.203 13.7664 13.3901 13.8788C13.5773 13.9911 13.7915 14.0505 14.0098 14.0505H14.1939C14.5133 14.0505 14.8196 13.9236 15.0454 13.6978C15.2713 13.4719 15.3981 13.1657 15.3981 12.8463V10.3259C15.3981 9.89176 15.1663 9.51466 14.8216 9.30298Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 3.22253V8.93447",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.99969 4.64513C9.78534 4.64513 10.4222 4.00824 10.4222 3.22259C10.4222 2.43694 9.78534 1.80005 8.99969 1.80005C8.21404 1.80005 7.57715 2.43694 7.57715 3.22259C7.57715 4.00824 8.21404 4.64513 8.99969 4.64513Z",
    fill: "#E15C64",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M10.1769 2.42322C10.1398 2.69258 10.0635 2.95505 9.95029 3.20226C9.61495 3.94098 9.02311 4.43886 8.45215 4.53534C8.73495 4.65341 9.04833 4.677 9.34562 4.60259C9.64291 4.52818 9.90823 4.35976 10.1021 4.12238C10.2959 3.88501 10.4079 3.59138 10.4214 3.28522C10.4349 2.97905 10.3491 2.67671 10.1769 2.42322Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.80576 14.0503H3.9899C4.30928 14.0503 4.61557 13.9234 4.8414 13.6976C5.06723 13.4718 5.1941 13.1655 5.1941 12.8461V10.3259C5.1941 10.0065 5.06723 9.70024 4.8414 9.47441C4.61557 9.24858 4.30928 9.1217 3.9899 9.1217H3.80576C3.48639 9.1217 3.1801 9.24858 2.95426 9.47441C2.72843 9.70024 2.60156 10.0065 2.60156 10.3259V12.8463C2.60161 13.1656 2.7285 13.4719 2.95433 13.6976C3.18015 13.9234 3.48642 14.0503 3.80576 14.0503Z",
    fill: "#666766",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M4.49559 9.23401C4.50423 9.29197 4.50999 9.35083 4.50999 9.41113V11.9315C4.50999 12.2509 4.38312 12.5572 4.15729 12.783C3.93146 13.0088 3.62516 13.1357 3.30579 13.1357H3.12165C2.947 13.1355 2.7745 13.0972 2.61621 13.0234C2.70207 13.6042 3.20121 14.0504 3.80583 14.0504H3.98997C4.14811 14.0504 4.3047 14.0193 4.4508 13.9588C4.5969 13.8983 4.72965 13.8096 4.84147 13.6977C4.95329 13.5859 5.04199 13.4532 5.10251 13.3071C5.16302 13.161 5.19417 13.0044 5.19417 12.8462V10.3259C5.19415 10.0962 5.12835 9.87128 5.00456 9.67779C4.88076 9.4843 4.70414 9.3303 4.49559 9.23401Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.8962 16.2001H5.10363C4.85858 16.2001 4.62358 16.1027 4.4503 15.9295C4.27703 15.7562 4.17969 15.5212 4.17969 15.2761V7.45189C4.17969 7.20685 4.27703 6.97184 4.4503 6.79857C4.62358 6.6253 4.85858 6.52795 5.10363 6.52795H12.8964C13.1414 6.52795 13.3764 6.6253 13.5497 6.79857C13.723 6.97184 13.8203 7.20685 13.8203 7.45189V15.2761C13.8203 15.5212 13.7229 15.7562 13.5496 15.9295C13.3763 16.1027 13.1412 16.2001 12.8962 16.2001Z",
    fill: "#E0E0E0",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    d: "M12.8964 6.52795H12.6204V14.1175C12.6204 14.3625 12.5231 14.5975 12.3498 14.7708C12.1765 14.9441 11.9415 15.0414 11.6965 15.0414H4.17969V15.2761C4.17969 15.5212 4.27703 15.7562 4.4503 15.9295C4.62358 16.1027 4.85858 16.2001 5.10363 16.2001H12.8964C13.1414 16.2001 13.3764 16.1027 13.5497 15.9295C13.723 15.7562 13.8203 15.5212 13.8203 15.2761V7.45189C13.8203 7.20685 13.723 6.97184 13.5497 6.79857C13.3764 6.6253 13.1414 6.52795 12.8964 6.52795Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.82952 12.5907C6.68634 12.5907 6.54457 12.6189 6.41229 12.6737C6.28002 12.7285 6.15983 12.8088 6.05859 12.91C5.95735 13.0113 5.87704 13.1315 5.82225 13.2637C5.76746 13.396 5.73926 13.5378 5.73926 13.681C5.73926 13.9701 5.85412 14.2474 6.05859 14.4519C6.26305 14.6564 6.54036 14.7712 6.82952 14.7712H7.12796V12.5907H6.82952Z",
    fill: "currentColor",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.12793 12.5907H8.37569V14.7714H7.12793V12.5907Z",
    fill: "currentColor",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.37598 12.5907H9.62374V14.7714H8.37598V12.5907Z",
    fill: "currentColor",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11.1695 12.5907H10.8711V14.7714H11.1695C11.4587 14.7714 11.736 14.6565 11.9405 14.4521C12.1449 14.2476 12.2598 13.9703 12.2598 13.6811C12.2598 13.5379 12.2316 13.3962 12.1769 13.2639C12.1221 13.1316 12.0418 13.0114 11.9405 12.9101C11.8393 12.8088 11.7191 12.7285 11.5868 12.6737C11.4545 12.6189 11.3127 12.5907 11.1695 12.5907Z",
    fill: "currentColor",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.62305 12.5907H10.8708V14.7714H9.62305V12.5907Z",
    fill: "currentColor",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M6.9885 10.6713C7.57921 10.6713 8.05807 10.1925 8.05807 9.60179C8.05807 9.01108 7.57921 8.53223 6.9885 8.53223C6.3978 8.53223 5.91895 9.01108 5.91895 9.60179C5.91895 10.1925 6.3978 10.6713 6.9885 10.6713Z",
    fill: "#ACBD81",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.01 10.6713C11.6007 10.6713 12.0795 10.1925 12.0795 9.60179C12.0795 9.01108 11.6007 8.53223 11.01 8.53223C10.4193 8.53223 9.94043 9.01108 9.94043 9.60179C9.94043 10.1925 10.4193 10.6713 11.01 10.6713Z",
    fill: "#ACBD81",
    stroke: "#333333",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M5.10449 9.83252V9.99902",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M5.10449 7.62756V8.93454",
    stroke: "white",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.2,
    d: "M5.79102 14.01C5.86096 14.2309 5.99941 14.4237 6.18632 14.5606C6.37322 14.6974 6.59886 14.7712 6.83052 14.7712H11.1707C11.6581 14.7712 12.0707 14.4512 12.2102 14.01H5.79102Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/IMAGE.20e1e8a45abe0110d32a2c1d936caa14.svg";
export { ForwardRef as ReactComponent };